"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Dropdown_meta_1 = require("./Dropdown.meta");

var mobx_1 = require("mobx");

var Translate_1 = require("../../base/Translate/Translate");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Header_1 = __importDefault(require("./styledComponents/Header"));

var HeaderTitle_1 = __importDefault(require("./styledComponents/HeaderTitle"));

var HeaderIcon_1 = __importDefault(require("./styledComponents/HeaderIcon"));

var List_1 = __importDefault(require("./styledComponents/List"));

var ListItems_1 = __importDefault(require("./styledComponents/ListItems"));

var ListItem_1 = __importDefault(require("./styledComponents/ListItem"));

var ClickLayer_1 = __importDefault(require("../ClickLayer/ClickLayer"));

var ListItemCheckboxWrapper_1 = __importDefault(require("./styledComponents/ListItemCheckboxWrapper"));

var ListItemLabel_1 = __importDefault(require("./styledComponents/ListItemLabel"));

var Translate_2 = __importDefault(require("../Translate"));

var Image_1 = __importDefault(require("../Image"));

var Checkbox_1 = __importDefault(require("../Checkbox"));

var Label_1 = __importDefault(require("./styledComponents/Label"));

var Dropdown =
/** @class */
function (_super) {
  __extends(Dropdown, _super);

  function Dropdown(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = Dropdown_meta_1.DROPDOWN_CATEGORY_KEY;
    _this.componentKey = Dropdown_meta_1.DROPDOWN_COMPONENT_KEY;
    _this.isOpen = false;

    _this.toggleSelectedValue = function (value) {
      var values;

      if (_this.isMultiSelect) {
        values = __spreadArrays(_this.selectedItems.map(function (item) {
          return item.value;
        }));

        if (_this.isValueSelected(value)) {
          values = values.filter(function (selectedValue) {
            return selectedValue !== value;
          });
        } else {
          values.push(value);
        }
      } else {
        values = [value];
      }

      _this.selectedValues = values;
    };

    _this.toggleOpen = function () {
      if (!_this.singleItemDisplayOnly) {
        _this.isOpen = !_this.isOpen;
      }
    };

    _this.handleOnChange = function (e, value) {
      e.preventDefault();
      var onChange = _this.props.onChange;
      var items = _this.items;

      _this.toggleSelectedValue(value);

      if (!_this.isMultiSelect) {
        _this.toggleOpen();
      }

      if (!ksys_app_template_1.utils.typeChecks.isNullOrEmpty(value) && onChange) {
        onChange(_this.isMultiSelect ? _this.selectedItems : _this.selectedItems[0]);
      }
    };

    return _this;
  }

  Object.defineProperty(Dropdown.prototype, "selectedItemsFromProps", {
    get: function get() {
      var selectedItem = this.props.selectedItem;
      return this.convertToArray(selectedItem);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Dropdown.prototype, "selectedItems", {
    get: function get() {
      var _this = this;

      var items = this.items;
      var selectedItems;

      if (items && items.length > 0) {
        if (this.selectedValues) {
          var isValueSelected_1 = function isValueSelected_1(value) {
            if (_this.selectedValues !== undefined) {
              return _this.selectedValues.find(function (selectedValue) {
                return selectedValue === value;
              }) !== undefined;
            }

            return false;
          };

          selectedItems = items.filter(function (item) {
            return isValueSelected_1(item.value);
          });
        }

        if (!selectedItems && this.selectedItemsFromProps.length > 0) {
          var isItemPreSelected_1 = function isItemPreSelected_1(item) {
            return _this.selectedItemsFromProps.find(function (selectedItem) {
              return selectedItem.value === item.value;
            }) !== undefined;
          };

          selectedItems = items.filter(function (item) {
            return isItemPreSelected_1(item);
          });
        }
      }

      if (selectedItems && selectedItems.length > 1 && !this.isMultiSelect) {
        selectedItems = [selectedItems[0]];
      }

      return selectedItems || [];
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Dropdown.prototype, "selectedDisplayItem", {
    get: function get() {
      var _a = this.props.selectedPlaceholder,
          selectedPlaceholder = _a === void 0 ? '{selected} selected' : _a;

      var selectedStateItems = __spreadArrays(this.selectedItems);

      if (selectedStateItems.length === 0) {
        selectedStateItems.push(this.placeholder);
      }

      var label = '';

      if (selectedStateItems.length > 1) {
        var values = {
          selected: selectedStateItems.length
        };

        if (this.translationContext) {
          label = this.translationContext.translate(selectedPlaceholder, values);
        }

        label = ksys_app_template_1.utils.replacePlaceholders(values, label);
      } else {
        if (this.translationContext) {
          label = this.translationContext.translate(selectedStateItems[0].label);
        } else {
          label = selectedStateItems[0].label;
        }
      }

      return {
        label: label,
        value: ''
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Dropdown.prototype, "placeholder", {
    get: function get() {
      var placeholder = this.props.placeholder;
      return {
        value: '',
        label: placeholder
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Dropdown.prototype, "singleItemDisplayOnly", {
    get: function get() {
      var _a = this.props,
          _b = _a.singleItemDisplayOnly,
          singleItemDisplayOnly = _b === void 0 ? false : _b,
          _c = _a.items,
          items = _c === void 0 ? [] : _c;
      return singleItemDisplayOnly && items.length === 1;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Dropdown.prototype, "isMultiSelect", {
    get: function get() {
      var _a = this.props.isMultiSelect,
          isMultiSelect = _a === void 0 ? false : _a;
      return isMultiSelect;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Dropdown.prototype, "items", {
    get: function get() {
      var _a = this.props,
          _b = _a.items,
          propsItems = _b === void 0 ? [] : _b,
          placeholder = _a.placeholder,
          _c = _a.includePlaceholderItem,
          includePlaceholderItem = _c === void 0 ? false : _c;

      var items = __spreadArrays(propsItems);

      if (includePlaceholderItem && !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(placeholder)) {
        items.unshift(this.placeholder);
      }

      return items;
    },
    enumerable: true,
    configurable: true
  });

  Dropdown.prototype.selectSingleItem = function () {
    var _a = this.props.items,
        items = _a === void 0 ? [] : _a;

    if (items.length === 1) {
      this.selectedValues = [items[0].value];
    }
  };

  Dropdown.prototype.isItemSelected = function (item) {
    return this.selectedItems.filter(function (selectedItem) {
      return selectedItem.value === item.value;
    }).length > 0;
  };

  Dropdown.prototype.isValueSelected = function (value) {
    return this.selectedItems.filter(function (selectedItem) {
      return selectedItem.value === value;
    }).length > 0;
  };

  Dropdown.prototype.convertToArray = function (values) {
    if (values) {
      if (!ksys_app_template_1.utils.isArrayLike.isArrayLike(values)) {
        return [values];
      }

      if (ksys_app_template_1.utils.isArrayLike.isArrayLike(values)) {
        return values;
      }
    }

    return [];
  };
  /**
   * Opposed to doing a JSON.stringify (which can cause circular reference), we compare values for change
   */


  Dropdown.prototype.hasSelectedChanged = function (currSelected, nextSelected) {
    if (currSelected.length !== nextSelected.length) {
      return true;
    }

    if (currSelected.length === nextSelected.length && currSelected.length > 0) {
      var _loop_1 = function _loop_1(i) {
        var currItem = currSelected[i];

        if (nextSelected.find(function (nextItem) {
          return nextItem.value === currItem.value;
        }) === undefined) {
          return {
            value: true
          };
        }
      };

      for (var i = 0; i < currSelected.length; i++) {
        var state_1 = _loop_1(i);

        if (typeof state_1 === "object") return state_1.value;
      }
    }

    return false;
  };

  Dropdown.prototype.componentWillReceiveProps = function (props) {
    // this logic allows a parent component to manage the selected values, opposed to the default internal state management
    var nextSelected = this.convertToArray(props.selectedItem);
    var currSelected = this.convertToArray(this.props.selectedItem);

    if (this.hasSelectedChanged(currSelected, nextSelected)) {
      this.selectedValues = nextSelected.map(function (item) {
        return item.value;
      });
    }
  };

  Dropdown.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        _b = _a.checkboxPosition,
        checkboxPosition = _b === void 0 ? 'left' : _b,
        label = _a.label;
    var items = this.items;
    var image = this.isOpen ? 'base.dropdown.caretUp' : 'base.dropdown.caretDown';

    if (this.singleItemDisplayOnly && ksys_app_template_1.utils.typeChecks.isNullOrEmpty(this.selectedValues)) {
      this.selectSingleItem();
    }

    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, label && react_1.default.createElement(Label_1.default, {
      value: label
    }), react_1.default.createElement(Header_1.default, {
      onClick: function onClick() {
        return _this.toggleOpen();
      }
    }, react_1.default.createElement(HeaderTitle_1.default, null, react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
      _this.translationContext = translationContext;
      return _this.selectedDisplayItem.label;
    })), !this.singleItemDisplayOnly && react_1.default.createElement(HeaderIcon_1.default, null, react_1.default.createElement(Image_1.default, {
      asset: image
    }))), this.isOpen && react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(ClickLayer_1.default, {
      onClick: this.toggleOpen
    }), react_1.default.createElement(List_1.default, null, react_1.default.createElement(ListItems_1.default, null, items.map(function (item) {
      return react_1.default.createElement(ListItem_1.default, {
        key: item.value,
        onClick: function onClick(e) {
          return _this.handleOnChange(e, item.value);
        }
      }, _this.isMultiSelect && checkboxPosition === 'left' && react_1.default.createElement(ListItemCheckboxWrapper_1.default, null, react_1.default.createElement(Checkbox_1.default, {
        value: _this.isItemSelected(item),
        onChange: function onChange(e) {
          return _this.handleOnChange(e, item.value);
        }
      })), react_1.default.createElement(ListItemLabel_1.default, null, react_1.default.createElement(Translate_2.default, null, item.label)), _this.isMultiSelect && checkboxPosition === 'right' && react_1.default.createElement(ListItemCheckboxWrapper_1.default, null, react_1.default.createElement(Checkbox_1.default, {
        value: _this.isItemSelected(item),
        onChange: function onChange(e) {
          return _this.handleOnChange(e, item.value);
        }
      })));
    })))));
  };

  __decorate([mobx_1.observable], Dropdown.prototype, "isOpen", void 0);

  __decorate([mobx_1.observable.ref], Dropdown.prototype, "selectedValues", void 0);

  __decorate([mobx_1.action], Dropdown.prototype, "toggleSelectedValue", void 0);

  __decorate([mobx_1.action], Dropdown.prototype, "toggleOpen", void 0);

  __decorate([mobx_1.action], Dropdown.prototype, "handleOnChange", void 0);

  __decorate([mobx_1.computed], Dropdown.prototype, "selectedItemsFromProps", null);

  __decorate([mobx_1.computed], Dropdown.prototype, "selectedItems", null);

  __decorate([mobx_1.computed], Dropdown.prototype, "selectedDisplayItem", null);

  __decorate([mobx_1.computed], Dropdown.prototype, "placeholder", null);

  __decorate([mobx_1.computed], Dropdown.prototype, "singleItemDisplayOnly", null);

  __decorate([mobx_1.computed], Dropdown.prototype, "isMultiSelect", null);

  __decorate([mobx_1.computed], Dropdown.prototype, "items", null);

  Dropdown = __decorate([mobx_react_1.observer], Dropdown);
  return Dropdown;
}(shared_1.ComponentBase);

exports.Dropdown = Dropdown;
exports.default = shared_1.InjectedStyledComponent(Dropdown, Dropdown_meta_1.DROPDOWN_CATEGORY_KEY, Dropdown_meta_1.DROPDOWN_COMPONENT_KEY);